import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/api";
import { Mail, CheckCircle2, ArrowLeft } from "lucide-react";


export default function PortalForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/portal/forgot-password`, {
        email,
        origin: window.location.origin,
      });
    } catch { /* réponse toujours générique côté serveur */ }
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-[#072354] to-[#2877D1]">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden" data-testid="portal-forgot-card">
        <div className="px-6 py-7 text-white text-center bg-gradient-to-r from-[#072354] to-[#2877D1]">
          <div className="flex items-center justify-center gap-3 mb-1">
            <img src="/dg-logo.png" alt="DG Fiscal Flow" className="w-12 h-12 object-contain" />
            <div className="text-left">
              <h1 className="text-xl font-bold">DG Fiscal Flow</h1>
              <p className="text-xs text-blue-200">Espace client</p>
            </div>
          </div>
        </div>

        {sent ? (
          <div className="p-6 space-y-4 text-center" data-testid="portal-forgot-success">
            <CheckCircle2 className="w-12 h-12 text-green-500 mx-auto" />
            <h2 className="text-base font-semibold text-gray-700">Vérifiez votre boîte courriel</h2>
            <p className="text-sm text-gray-500">
              Si <strong>{email}</strong> correspond à un compte, un lien de réinitialisation vient d'être envoyé.
              Il est valide pendant 1 heure. Pensez à vérifier vos courriers indésirables.
            </p>
            <Link to="/portal" className="inline-flex items-center gap-1 text-sm text-[#2877D1] hover:underline" data-testid="back-to-login-link">
              <ArrowLeft className="w-4 h-4" /> Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="p-6 space-y-4" data-testid="portal-forgot-form">
            <h2 className="text-base font-semibold text-gray-700 text-center">Mot de passe oublié</h2>
            <p className="text-sm text-gray-500 text-center">
              Entrez le courriel associé à votre compte et nous vous enverrons un lien sécurisé pour choisir un nouveau mot de passe.
            </p>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Courriel</label>
              <div className="relative">
                <Mail className="absolute left-3 top-3.5 w-4 h-4 text-gray-400" />
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                  className="w-full pl-9 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#072354] focus:ring-2 focus:ring-[#072354]/20 text-sm"
                  placeholder="votre@courriel.com" data-testid="forgot-email-input" autoFocus />
              </div>
            </div>
            <button type="submit" disabled={loading || !email}
              className="w-full text-white py-3 rounded-lg transition font-medium disabled:opacity-50 text-sm bg-[#072354] hover:bg-[#0a2d6e]"
              data-testid="forgot-submit-btn">
              {loading ? "Envoi..." : "Envoyer le lien de réinitialisation"}
            </button>
            <div className="flex justify-center">
              <Link to="/portal" className="inline-flex items-center gap-1 text-sm text-gray-500 hover:underline" data-testid="forgot-back-link">
                <ArrowLeft className="w-4 h-4" /> Retour à la connexion
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
